// import fetch from '../config/fetch'
import { getSign, canvasAuth } from "../config/mUtils";
// import axios from 'axios'
/**
 * 验证规则
 */
export const aric = apiUrl + "global/ARIC?random" + Math.random();
/**
 * 是否有新消息及新订单
 */
export const navCount = apiUrl + "my/NavCount";
/**
 * 经纬度获取城市信息
 */
export const locationCity = apiUrl + "global/getCityInfoByGeo";
export const getLocation = geoUrl + "geo/getcityinfobygeo";
/**
 * 获取首页轮播
 */
export const getBanner =
  "/mobile/html5/getIndexRecommendLodgeunit?timestamp=1433152916898&sign=497a64d9f784ffd92993df3e5c67a264";
/**
 * 获取热门城市列表（新）
 */
export const getHotCity = apiUrl + "global/hotcitys";
/**
 * 获取城市列表（新）
 */
export const getAllCity = houseUrl + "global/allcitys";
/**
 * 热门地标
 */
export const hotArea = apiUrl + "global/hotrecommend";
/**
 * 城市搜索
//  */
export const searchCity = apiUrl + "faxian/suggestionV3";
// export const searchCity = apiUrl + 'faxian/suggestion';
/**
 * 获取日记
 */
export const fetchEliteDiary =
  mobileUrl +
  "fetchEliteDiary?timestamp=1433152916900&sign=79b96b9ffc1c61186b0e47face8d19d0";

/**
 * 航班管家获取三方信息
 */
export const getThirdInfo = goServiceUser + "user/third/info"; 
/**
 * * 航班管家app静默登陆
 */
export const hbgjLogin = hbgjSendLogin + "User/hbgjLogin"; 

/**
 * 普通登录
 */
export const normalLog = vipUrl + "user/login4pwd";
/**
 * 快速登录
 */
export const quickLog = apiUrl + "user/NewQuickLogin";

/**
 * 获取图片验证码
 */
export const getImgVeryCode = () =>
  fetch(apiUrl + "user/ImageCode", {
    timestamp: new Date().getTime(),
    sign: getSign("getSign")
  });
/**
 * 获取国家列表
 */
export const getNationList = "static/json/nation.json";
/**
 * 获取安卓app包列表
 */
export const androidApp = "static/json/androidApp.json";
/**
 * 登录加载信息
 */
export const preInformation = apiUrl + "global/preInformation";
/**
 * 快速注册验证
 */
export const preVery = apiUrl + "user/CheckParams4H5";
/**
 * 快速登录验证通过后获取手机验证码
 */
export const getSms = apiUrl + "user/QuickSendSmsCode";
/**
 * 独立部署 快速登录验证通过后获取手机验证码
 */
export const getSms2 = sendCode + "user/QuickSendSmsCode";
/**
 * 邮箱找回密码  
 */
export const getPassWordEmail = apiUrl + "user/sendEmail";
/**
 * 手机号，验证码等验证规则
 */
export const checkAllParams = apiUrl + "user/CheckParams4H5";
/* 房源搜索结果 */
export const getResultList = listUrl + "search/result";
/* 获取地区 */
export const getArea = houseUrl + "global/areaandlandmark";
/* 房源详情 */
export const getHouseDetail = houseUrl + "detail/index";
/* 房东详情 */
export const getlandlord = apiUrl + "Fangdong/index";
/* 日历 */
export const bookCalendar = roomnightsUrl + "lodgeUnit/luPrice";
/* 酒店详情 */
export const hotelDetail = houseUrl + "hotel/hotel-detail-all";

/* token */
export const xztokenExchange = xztoken =>
  fetch(goServiceUser + "user/xztokenexchange", {
    xztoken
  });

export const vipCart = (id, number, password) =>
  fetch(
    "/member/v1/users/" + id + "/delivery_card/physical_card/bind",
    {
      number,
      password
    },
    "POST"
  );

// 个人中心
export const myInfo = apiUrl + "my/index";
// 个人中心-红包兑换
export const exchangeRedPackge = apiUrl + "my/exchangeRedPackge";
// 个人中心-分享邀请码
export const inviteCode = sendCode + "invite/inviteCode";
// 个人中心-自定义邀请码
export const UpdateInviteCode = sendCode + "invite/inviteInfoById";
// 找回密码-重置新密码-短信
export const ResetPwdByMobile = apiUrl + "user/ResetPwdByMobile";
// 找回密码-验证邮箱
export const checkEmailValiCode = apiUrl + "user/checkEmailValiCode";
// 找回密码-重置新密码-邮箱
export const resetPwdByEmail4h5 = apiUrl + "user/resetPwdByEmail4h5";
// 注册-设置用户名密码
export const Register4AppH5 = apiUrl + "user/Register4AppH5";
// 搜索
export const getSuggestionV3 = apiUrl + "faxian/suggestionV3";
// 房源筛选标识
export const getAreaAndlandmark = apiUrl + "global/areaandlandmark";
// 个人中心-收藏列表
export const groupList = vipUrl + "favorite/favoriteList";
// 个人中心-新增收藏组
export const addGroup = vipUrl + "favorite/addGroup";
// 个人中心-收藏房源列表
export const groupDetail = vipUrl + "favorite/groupDetail";
// 个人中心-取消收藏
export const cancelCollect = vipUrl + "favorite/cancelAll";
// 个人中心-点评列表
export const commentList = geoUrl + "comment/list";
// 个人中心-点评详情
export const detailByOrderId = commentApi + "comment/DetailByOrderId";
// 个人中心-删除点评
export const deleteComment = commentApi + "comment/delete";
// 个人中心 - 免押认证
export const cashpledgeFreeVerify = apiUrl + "My/UserIdentityAuth";
// 个人中心 - 查询是否免押
export const CheckUserIdAuth = apiUrl + "My/CheckUserIdAuth";
// 详情页 - 推荐房源
export const roomRecommed = searchUrl + "detail/roomRecommend";
// 详情页 - 全部点评
export const allComment = geoUrl + "comment/commentlist";
// 详情页 - 房东的全部点评
export const allLandlordComment = geoUrl + "comment/allcomments";
// 个人中心&详情页 - 添加&移动收藏房源
export const addFavorite = vipUrl + "favorite/addFavorite";
// 个人中心&详情页 - 查询该房源可移动的收藏组
export const addFavoriteInfo = vipUrl + "favorite/addFavoriteInfo";
// 登录注册 - 第三方登录
export const OpenApiUserLogin4html5 = apiUrl + "user/OpenApiUserLogin4html5";
// 登录注册 - 获取滑动验证token
export const GetSlideVerifyToken =
  verifyNew + "slideVerify/check?role=xzfd&clientFrom=html5&clientVersion=500";
// 登录注册 - 获取滑动验证方式
export const GetSlideVerifyType =
  verifyNew +
  "v2/slideVerify/type?role=xzfd&clientFrom=html5&clientVersion=500";
//极验注册接口
export const geetestRegister = verifyNew + "geetest/register";
// 个人中心 - 提交新点评
export const commentPublish = commentApi + "comment/publish";
// 详情页 - 取消对指定房源的收藏
export const cancelfavorite = vipUrl + "favorite/cancelAll";
// 详情页 - 领券
export const doSendCouponByUser = apiUrl + "activity/doSendCouponByUser";
// 详情页 - 全部活动
export const allActivity = allActivityUrl + "detail/allActivity";
// 详情页 - 计算日历价格
export const calculatePrice = orderUrl + "book/calculatePrice";
// 详情页 - 计算日历价格
export const calculatePriceV3 = orderUrl + "book/calculatePriceV3";
// agoda房源邮件发送
export const agodaBookPartnerSetNewsLetterUrl =
  apiUrl + "book/partnersetnewsletter";

// 支付；
export const payOrder = `${payUrl}pay/submit`;
// 支付状态；
export const payStatus = `${payUrl}pay/status`;
// 获取支付信息；
export const getPayInfo = `${payUrl}pay/getPayInfo`;
// 闲鱼合作获取验证码；
export const xianYuSms = apiUrl + "user/QuickSendSmsCodeXianyu";
// 独立部署 闲鱼合作获取验证码；
export const xianYuSms2 = sendCode + "user/QuickSendSmsCodeXianyu";
// 闲鱼登录接口；
export const getXianYuLuid = openUrls + "distribution/transferId4XianYu";
export const xianYuLogin = apiUrl + "User/QuickLoginAndRegister";
export const PayMethod = payUrl + "pay/paymethod";
// 获取故事页
export const story = apiUrl + "discovery/StoryDetail";
// 故事页-房源
export const storyOtherInfo = apiUrl + "Discovery/StoryOtherInfo";
// 故事页-品牌卡片
export const storyStoreInfo = houseUrl + "lodgeUnit/getBrandStoreInfo";
// 品牌页-描述
export const brandInfo = houseUrl + "lodgeUnit/getBrandStoreDetail";
// 品牌页-房源
export const brandList = houseUrl + "lodgeUnit/getBrandStoreLuList";
// 商旅发票邮寄地址
export const billDressList = sendCode + "userAddress/userAddressList";
export const billAddDress = sendCode + "userAddress/userAddressOperate";
// 商旅发票列表
export const billList = billUrl + "supplement/getInvoiceOrderList";
// 取消商旅发票订单
export const cancelBill = billUrl + "supplement/cancelInvoicePay";
// 商旅发票列表
export const billlHeaderList = billUrl + "supplement/getBillTitleList";
// 添加，修改、删除发票抬头
export const billlHeaderEdit = billUrl + "supplement/submitBill";
export const billlHeaderDel = billUrl + "supplement/removeBill";
// 提交商旅发票
export const submitBills = billUrl + "supplement/submitInvoice";
// 发票详情
export const billlHeaderDetail = billUrl + "supplement/getBillDetail";
// 发票v6详情
export const billV6Detail = billUrl + "invoice/getDetail";
// 发票v6 获取物流信息
export const billV6PostInfo = manageUrl + "invoice/getlogisticsdetail";
// 发票v6 修改邮箱
export const sendElectronicEmail = billUrl + "invoice/sendElectronicEmail";
//资金合规发票最新抬头
export const billNewDetail = newBillUrl + "invoice/billv/getbillvbyuser";
//资金合规下单流程的提交
export const billNewsubmit = newBillUrl + "invoice/billv/submitbillv";
//资金合规新发票工单详情
export const billSheetDetail = newBillUrl + "invoice/collect/sheetdetailofapp";
//资金合规新发票工单修改
export const billSheetEdit = newBillUrl + "invoice/collect/editinvoicesheet";
//资金合规用户申请补开的基础信息
export const addBillDetail = newBillUrl + "invoice/collect/pendinginfo";
//资金合规用户补开提交
export const addBillSubmit = newBillUrl + "invoice/collect/submitsupplyinvoice";
// 马蜂窝补开发票登录页面
export const nestBillLogin = sendCode + "apiUser/loginByCode";
// 故事页-分享
export const storySmlImgInfo = apiUrl + "discovery/storySmlImgInfo";
// 线下服务中心；
// 获取门店信息
export const siteDetail =
  officeLine + "serviceCenter/getNearestCenterSiteDetails";
// 获取所有门店
export const allSites = officeLine + "serviceCenter/getCityCenterSite";
// 获取站点详情
export const siteInfos = officeLine + "serviceCenter/getCenterSiteDetails";
// 获取城市所以站点
export const citySites = officeLine + "serviceCenter/getStaticCityCenterSite";
// 免押还款接口
export const cashFreeRePayUrl = apiUrl + "order/depositOperate";
// 砍价销小手儿
export const showBragian = apiUrl + "activity/appPageShowInfo";
// 查询会员
export const getVipInfo = vipUrl + "external/member/getMemberInfo";
// 获取会员开通记录；
export const vipList = vipUrl + "external/member/getMemberOrderList";
// 获取会员精选活动
export const vipActivityList = apiUrl + "global/vipCenterBanner";
// 购买会员
export const bugVip = vipUrl + "external/member/createMember";
// 续费会员；
export const renewalMember = vipUrl + "external/member/renewalMember";
// 优选房源
export const getPriorityRoom = apiUrl + "search/memberPriorityRoom";
// 优选房源城市列表
export const getCityList = apiUrl + "search/GetVipCity";
// 获取首页banner
export const getIndexBanner = apiUrl + "global/indexBackground";
// 换取token
export const exchangeXztoken = goServiceUser + "user/xztokenexchange";
// 数据统计；
export const statisticLuData =
  statisticsUrl + "activity/relateActivityUserShip";
// 订单详情页
export const getDetail = orderUrl + "tenantOrder/detail";
// im营销；
export const imMarker = apiUrl + "Marketing/ImHeadH5Notice";
// 分享配置接口
export const sharePath = shareUrl + "wechat/jsconf";
// 向您推荐
export const getLodgeUnitInfoByLuIds =
  apiUrl + "search/getLodgeUnitInfoByLuIds";
// 房东房客协商退款
export const refundDetail = orderUrl + "tenantRefund/detail";
export const refundState = orderUrl + "tenantRefund/update";
// 搜索V4
export const searchPath = searchUrl + "search/suggestionCity";
export const searchLandmark = searchUrl + "search/suggestionLandmark";
// 退款进度
export const refundProcess = orderUrl + "tenantOrder/getSpecialProcess";
// 退款详情
export const refundProcessDetail = orderUrl + "tenantOrder/refundDetail";
// 系统消息
export const systemList = apiUrl + "systemMessage/getList";
// 删除系统推送
export const systemDel = apiUrl + "my/delNotice";

// 获取学生认证信息
export const getStudentUserInfo = vipUrl + "identify/getStudentUserInfo";
// 获取最新邀请信息列表
export const lastInviteInfo = vipUrl + "invite/lastInviteInfo";
export const newInviterInfo = vipUrl + "invite/newInviterInfo";
// 获取邀请人信息
export const myInviteInfo = vipUrl + "invite/myInviteInfo";
// 接受邀请页面，获取邀请人信息
export const inviteInfo = vipUrl + "invite/inviteInfo";
// 邀请码埋点
export const inviteUserRecord = vipUrl + "invite/inviteUserRecord";
// lose工单
export const loseList = houseUrl + "lucenter/price/priceCompareList";
// 追价
export const loseTask = houseUrl + "lucenter/price/priceMatchTask";
// 追价记录
export const loseRecord = houseUrl + "lucenter/price/getEvenPriceHistory";
// 首页改版
export const indexSearch = searchUrl + "settings/html5HomePage";
// 超棒房东
// 个人中心 超棒房东
export const getGreatLandlord = goServiceUser + "growth/getgreatlandlord";
export const myGoodHistory = userService + "goodLandlord/myGoodHistory"; // 历史荣誉
export const voteGood = userService + "goodLandlord/voteGood"; // 本期进展
export const threshold = userService + "goodLandlord/threshold"; // 入门门槛
export const judgeState = userService + "goodLandlord/judgeState"; // 参选状态
export const voteIndex = userService + "goodLandlord/voteIndex"; // 季度评选接口接口
export const voteDetail = userService + "goodLandlord/voteDetail"; // 评选指标详情
// 房东任务 获取房东累计奖励
export const totalAward = landlordUrl + "lucenter/landlordTask/totalAward";
// 房东任务 获取房东任务列表
export const taskList = landlordUrl + "lucenter/landlordTask/laTaskLists";
// 房东任务 获取任务房源列表
export const taskLodgeUnitList =
  landlordUrl + "lucenter/landlordTask/taskLodgeUnitList";
// 房东任务 领取奖励
export const receiveReward =
  landlordUrl + "lucenter/landlordTask/receiveReward";
// 获取发票详情
export const getBillDetail = billUrl + "invoice/getPendingInvoice";
// 搜索发票抬头-请求阿里 根据抬头获取企业税号 ，目前没续费接口无法使用，日后可用再维护
export const getBillTitle = billUrl + "invoice/getAvailableTitle";
// 提交发票信息
export const submitBillInfo = billUrl + "invoice/submit";
// 获取订单开发票列表
export const billListV6 = billUrl + "invoice/getAllowOrderList";
//资金合规新的获取订单开发票列表
export const newBillListV6 = billListUrl + "invoice/order/list";
// 经营指导V3
// 获取房东房源列表
export const fdHouseList = bffUrl + "guide/homelist";
// 获取周边房源
export const areaList = bffUrl + "guide/nearby";
// 获取流失收入
export const getLossInfo = bffUrl + "guide/loss";
// 获取经营概况
export const getOverView = bffUrl + "guide/overview";
// 获取微信公众号APPID
export const getAppId = shareUrl + "wechat/getAppIdByType";
// 获取微信登录
export const getWxInfo = xzfdUrl + "user/wechatLogin";
// 砍价相关
// 砍价详情
export const bargainDetail = actSysUrl + "bargain/detail/get";
// 砍价成功列表
export const bargainSuccess = actSysUrl + "bargain/success/list";
// 是否展示砍价
export const bargainShow = actSysUrl + "bargain/order/vetify";
// 代金券列表
export const couponList = couponUrlNew + "customizeH5/couponList";
// 获取房东端房客退订规则
export const getRefundRules = houseUrl + "pubSys/CancelRulesV1";
// 获取房东端房客退订规则
export const updateRefundRules =
  houseUrl + "lodgeUnit/updateLandlordCancelRule";
// 房源通 我的房源推广数据
export const getLodgeUnitExtendData =
  adsUrl + "lodgeunit/getLodgeUnitExtendData";
// 房源通 房源列表
export const getLodgeUnitList = adsUrl + "lodgeunit/getLodgeUnitList";
// 房源通 获取投放周期
export const getExtendTime = adsUrl + "lodgeunit/getExtendTime";
// 房源通 房源推广楼层
export const getLodgeUnitFloor = adsUrl + "lodgeunit/getLodgeUnitFloor";
// 房源通 添加投放广告
export const addAds = adsUrl + "lodgeunit/addAds";
// 房源通 我的房源推广历史数据
export const getLodgeUnitHistoryExtendData =
  adsUrl + "lodgeunit/getLodgeUnitHistoryExtendData";
// 房源通 介绍页状态
export const fdPromotionCheck = userService + "fangdong/fdPromotionCheck";
// 获取入住人列表
export const getTenants = vipUrl + "book/getTenants";
// 获取自动回复开关
export const autoImState = imChat + "im/autoReply/switch";
// 自动回复开关
export const autoIm = imChat + "im/autoReply";
// 全部自动回复问题列表
export const autoImReply = imChat + "im/autoReplyListH5";
// 重构房东活动 #20274
// 活动迭代 20210709
// 获取房东可报名活动列表
export const landlordActivityList = activitySignup + "activity/list";
// 查询指定活动的详细信息接口
export const landlordActivityInfo = activitySignup + "activity/detail";
// 获取指定活动下可参与的房源列表接口
export const landlordLuList = activitySignup + "activity/lodgeunit/list";
// 房源报名参与促销活动
export const landlordSignUp = activitySignup + "activity/lodgeunit/signup";
// 获取已参加活动列表
export const landlordSignUpActivityList =
  activitySignup + "activity/signuplist";
// 指定房源退出指定活动
export const landlordLuSignOut = activitySignup + "activity/lodgeunit/signout";
// 已报名房源列表
export const landlordLuSignUpList =
  activitySignup + "activity/signup/lodgeunit/list";
// 往期活动列表
export const landlordHistorylist = activitySignup + "activity/historylist";
// 活动分享页
export const landlordActivityShare = activitySignup + "activity/share";
// 仅收集
export const landlordCollectSignUp = landlordActivity + "policy/collectSignUp";
// 房东活动报名记录-房源列表
export const landlordRecordLuList =
  activitySignup + "activity/record/lodgeunit/list";
// 获取指定活动房源下报名记录
export const landlordRecordList = activitySignup + "activity/record/list";
// 获取房东分销 - 分享领券
export const shareCoupon = actSysUrl + "distribution/getCouponRecord";
// 获取房东分销 - 返现奖励
export const cashBack = actSysUrl + "distribution/getCommissionRecord";

// 微信收付通功能模块 #20201202
// 获取银行列表
export const bankList = wxOtherUrl + "bank/getBankList";
// 获取银行支行列表
export const branchList = wxOtherUrl + "bank/getBankBranchList";
// 获取省份列表
export const bankProvinceList = wxOtherUrl + "bank/getBankProvinceList";
// 获取城市列表
export const bankCityList = wxOtherUrl + "bank/getBankCityList";

// 微信上传图片
export const wxUpladImg = imageUploadUrl + "imgin4uploadify.php";
// 添加资质信息 [营业执照]
export const wxAddBusinessAccount = wxOtherUrl + "merchant/addBusinessAccount";
// 添加用户信息 [身份证信息]
export const wxAddUserAccount = wxOtherUrl + "merchant/addUserAccount";
// 添加用户信息 [银行/管理员信息]
export const wxAddBankAccount = wxOtherUrl + "merchant/addBankAccount";
// 获取资质详情
export const getZZDetail = wxOtherUrl + "merchant/detail";
// 获取审核结果
export const getSupplytRes = wxOtherUrl + "merchant/getSupplytRes";

// 房东入住指南
export const landlordService = houseUrl + "guide/lodgeunit";

// 版本信息
export const appInfo = bffUrl + "appInfo/index";

// 公安系统
export const getPoliceMapList = landlordUrl + "common/getPoliceMapList";

// 获取管辖架构
export const getJur = landlordUrl + "pubsys/getPoliceInfo";

// 保存管辖机构
export const setJur = landlordUrl + "pubsys/savePoliceInfo";

// 巡房小助手 提交
export const feedbackHelp = actSysUrl + "user/feedback";

// 经营看板
export const tradeDataV4 = bdpApi + "api/house/trade_data_v4";
// 经营看板 房东房源
export const landlordLuListV4 = bdpApi + "api/landlord/landlord_lu_list_v4";
// 经营看板 图表数据
export const tradeTrendV4 = bdpApi + "api/house/trade_trend_v4";
// 用户屏蔽
export const imScreenOperate = imChat + "imInfo/imScreenOperate";
// 用户屏蔽  列表
export const getImReasonList = imChat + "config";
// 一键搬房 提交
export const moveLuByOneKey = landlordUrl + "tianpeng/storemovecreate";
// 客服满意度 提交
export const addSatisfy = customerSupport + "satisfy/add";
// 状态
export const isEvaluate = customerSupport + "satisfy/isEvaluate";

// 笔记详情
export const noteDetail = searchUrl + "home/getHomeNoteDetail";

// 判断笔记是否被收藏
export const collStatus = vipUrl + "favorite/isFavorite";

// 笔记收藏
export const collAdd = vipUrl + "favorite/addFavorite";

// 笔记取消收藏
export const collCancel = vipUrl + "favorite/cancelAll";

// 用户取消订单原因列表
export const earlyLeaveList = orderUrl + "tenantOrder/earlyLeaveV1";

// 用户取消订单原因 提交
export const earlyLeaveCancel = orderUrl + "tenantOrder/cancel";

// 供应商登陆换取id
export const changeSupplierOrderList =
  supplierUrl + "productSupplier/getByLoginIds";

// 房券供应商列表
export const supplierOrderList = supplierUrl + "productSupplier/orderList";

// 供应商订单详情接口
export const supplierOrderDetail = supplierUrl + "order/detail";

// 供应商预定操作接口
export const supplierSubmit = supplierUrl + "productSupplier/changeOrderStatus";

// 榜单列表
export const goodHouseList = activitySignup + "ranklist/list";
// 榜单匹配城市
export const getCityName = activitySignup + "ranklist/getranklistcity";

// 取消订单支付明细
export const getChargeDetail = orderUrl + "tenantOrder/chargeDetailV3";
// 取消订单
export const cancleOrder = orderUrl + "tenantOrder/cancel";
//助力免费拿 拼团首页
export const teamGroupIndex = actSysUrl + "teamGroup/index";
//助力免费拿 我的拼团
export const myTeamGroup = actSysUrl + "teamGroup/self/get";
//领取奖励
export const teamGroupReward = actSysUrl + "teamGroup/receive";
//创建拼团
export const createTeamGroup = actSysUrl + "teamGroup/create";
//获取分享信息
export const teamGroupShare = actSysUrl + "teamGroup/getShareInfo";
// 报名宣传页详情
export const getActivityDetail = landlordUrl + "lucenter/activity/detail";
// 跳转到企业微信
export const getadpositions = verifyUrl + "adposition/getadpositions";



// WEBPACK FOOTER //
// ./src/service/getData.js